import { FormattedMessage, useIntl } from "react-intl";
import React, { useMemo } from "react";
import DataTable from "react-data-table-component";
import { BiChevronUp } from "react-icons/bi";
import Empty from "./empty";
import { customStyles } from "./styles";
import { paginationOptions as options } from "./utils";
import { TableContainer } from "./styles";

export default function StaffDataTable({
  data = [],
  currentPage,
  setCurrentPage,
  rowsPerPage,
  setRowsPerPage,
  totalRows,
  setSortBy,
  setSortDirection,
}) {
  const intl = useIntl();
  const paginationOptions = {
    ...options({
      locale: intl.locale,
    }),
    disableNext: currentPage * rowsPerPage >= totalRows,
  };

  const columns = useMemo(() => {
    return [
      {
        id: "name",
        name: <FormattedMessage id={"name"} />,
        selector: (row) => row.name,
        sortable: true,
        style: {
          flex: 1,
        },
      },
      {
        id: "email",
        name: <FormattedMessage id={"email"} />,
        selector: (row) => row.email ?? "-",
        sortable: true,
        style: {
          flex: 1,
        },
      },
      {
        id: "totalServices",
        name: <FormattedMessage id={"number_of_calls"} />,
        selector: (row) => row.totalServices,
        sortable: true,
        style: {
          flex: 1,
        },
      },
      {
        id: "averageTime",
        name: <FormattedMessage id={"average_time_per_call"} />,
        selector: (row) => row.averageTime,
        sortable: false,
        style: {
          flex: 1,
        },
      },
    ];
  }, []);

  return (
    <TableContainer>
      <DataTable
        data={data}
        responsive
        noDataComponent={<Empty intlId="analytics_empty_text" />}
        columns={columns}
        customStyles={customStyles}
        sortIcon={<BiChevronUp style={{ display: "flex" }} />}
        paginationComponentOptions={paginationOptions}
        persistTableHead
        pagination
        paginationServer
        paginationPerPage={rowsPerPage}
        onChangePage={(page) => setCurrentPage(page)}
        onChangeRowsPerPage={(size) => {
          setCurrentPage(1);
          setRowsPerPage(size);
        }}
        paginationTotalRows={totalRows}
        onSort={(column, sortDirection) => {
          setSortBy(column.id);
          setSortDirection(sortDirection);
        }}
      />
    </TableContainer>
  );
}
